// extracted by mini-css-extract-plugin
export default {"cardsWrapper":"Integrations_cardsWrapper__8XT1S"};